const validProviders = ['WHATSAPP'];

// eslint-disable-next-line import/prefer-default-export
export const isValidProvider = (provider: string) =>
  validProviders.indexOf(provider);
